import { Shirt } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { RAIL_ITEM_STYLES } from '@/shared/ui';

interface ChangeProductLinkProps {
  /** 상품 상세 — 다른 색·상품을 고르러 돌아가는 곳. */
  readonly href: string;
}

/** 스테이지 도구 칸의 [상품 변경] — 상품 상세로 돌아간다. 저장하지 않은 편집은 임시 보관되지 않는다. */
export const ChangeProductLink = ({ href }: ChangeProductLinkProps): ReactElement => (
  <Link to={href} className={RAIL_ITEM_STYLES.item} title="상품 변경 — 상품 정보로 돌아가기">
    <Shirt aria-hidden className={RAIL_ITEM_STYLES.icon} strokeWidth={1.5} />
    <span className="whitespace-nowrap">상품 변경</span>
  </Link>
);
